import React from 'react';
import moment from 'moment';
import _ from 'lodash';

import { createCreditEntryTypes } from '../../../Entities/CreditEntry';

import InputCurrencyField from '../../Fields/InputCurrencyField';
import InputDateField from '../../Fields/InputDateField';
import InputSelectField from '../../Fields/InputSelectField';
import InputTextField from '../../Fields/InputTextField'

import {
  convertUnixMsToDateInTimezone,
  getCurrentDateInTimezone,
} from '../../../Utils/date';

import featureFlags from '../../../featureFlags';


class CreditEntryTableRow extends React.Component {
  _onChange(inputId) {
    return value => {
      const { onChange } = this.props;
      const creditEntry = _.cloneDeep(this.props.entry);
      creditEntry.fields[inputId].value = value;
      onChange(creditEntry);
    }
  }

  amountValidator = (value) => value >= 0;

  amountValidatorText = (
    <div className="parkchirp--credit-panel-entry-table--error-amountValidatorText">
      Amount must be POSITIVE.
    </div>
  );

  getTypeOptions() {
    const {
      newMode,
      fieldConfiguration,
    } = this.props;

    const typeOptions = fieldConfiguration.credit.type.options;

    if (newMode) {
      return typeOptions.filter(option => (createCreditEntryTypes.includes(option.value)));
    }

    return typeOptions;
  }

  getEntryDate() {
    const {
      entry,
      fieldConfiguration: {
        facilityTimezone
      }
    } = this.props;

    const entryDate = entry.fields.created_at.value;

    if (!entryDate) return new Date(getCurrentDateInTimezone(facilityTimezone));

    return new Date(convertUnixMsToDateInTimezone(entryDate, facilityTimezone));
  }

  render() {
    const {
      entry,
      inputId,
      newMode,
      applicationType,
      credit
    } = this.props;

    let invoiceId = "-";
    if (entry.fields.type.value === "OVERPAYMENT") {
      invoiceId = credit.fields.payment.value?.fields.invoice.value.fields.readable_id.value;
    } else if (entry.fields.type.value === "PAYMENT") {
      invoiceId = entry.fields.payment.value?.invoice.readable_id;
    }

    const isDNAC = applicationType === 'DO_NOT_APPLY_CASH';

    const typeOptions = this.getTypeOptions();

    const gross = entry.fields.amount.value
      + entry.fields.amount_tax_1.value
      + entry.fields.amount_tax_2.value
      + entry.fields.amount_tax_3.value
      + entry.fields.amount_tax_4.value;

    let applicationDate = entry.fields.application_date.value;
    if (applicationType === 'DO_NOT_APPLY_CASH') {
      switch (entry.fields.type.value) {
        case 'PAYMENT':
          const paymentEntry = entry.fields.payment.value.line_item_payments[0].payment_entry;
          applicationDate = paymentEntry.transaction.application_date;
          break;
        case 'RESTORATION':
          applicationDate = null;
          break;
        default:
      }
    }

    let negativeMode = false;
    switch (entry.fields.type.value) {
      case 'PAYMENT':
      case 'REVERSAL':
      case 'WRITE_OFF':
        negativeMode = true;
        break;
      default:
        negativeMode = false;
        break;
    }

    return (
      <div className="parkchirp--credit-panel-entry-table--row">
        {featureFlags.REVERSE_APPLICATIONDATE &&
          <>
            <div className="parkchirp--credit-panel-entry-table--trans-date-column parkchirp--credit-panel-entry-table--cell">
              <InputDateField inputId={`${inputId}--created-at`}
                value={this.getEntryDate()}
                editMode={false}
              />
            </div>
            {!this.props.isCarryoverCredit &&
              <div className="parkchirp--credit-panel-entry-table--app-date-column parkchirp--credit-panel-entry-table--cell">
                {applicationDate
                  ?
                  <InputDateField inputId={`${inputId}--created-at`}
                    value={moment(applicationDate).toDate()}
                    editMode={false}
                  />
                  : <span>-</span>
                }
              </div>
            }
          </>
        }
        {!featureFlags.REVERSE_APPLICATIONDATE && !this.props.isCarryoverCredit &&
          <div className="parkchirp--credit-panel-entry-table--date-column parkchirp--credit-panel-entry-table--cell">
            <InputDateField inputId={`${inputId}--created-at`}
              value={entry.fields.created_at.value || new Date()}
              editMode={false}
            />
          </div>
        }

        <div className="parkchirp--credit-panel-entry-table--type-column parkchirp--credit-panel-entry-table--cell">
          <InputSelectField inputId={`${inputId}--type`}
            value={entry?.fields?.type?.value}
            onChange={this._onChange('type')}
            options={typeOptions}
            editMode={newMode}
          />
        </div>
        {featureFlags.CREDIT_UPDATES &&
          <div className="parkchirp--credit-panel-entry-table--invoice-column parkchirp--credit-panel-entry-table--cell">
            <InputTextField inputId={`${inputId}--invoiceid`}
              value={invoiceId}
            />
          </div>
        }
        <div className="parkchirp--credit-panel-entry-table--net-amount-column parkchirp--credit-panel-entry-table--cell credit-net-amount">
          <InputCurrencyField inputId={`${inputId}--amount`}
            value={entry.fields.amount.value}
            key={`net-amount`}
            onChange={this._onChange('amount')}
            editMode={newMode}
            negativeMode={negativeMode}
            dashForNull={true}
            validator={this.amountValidator}
            validatorText={this.amountValidatorText}
          />
        </div>

        {featureFlags.OVERPAYMENT_PT2_C &&
          <>
            <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-1`}
                value={entry.fields.amount_tax_1.value}
                key={`amount--tax-2`}
                onChange={this._onChange('amount_tax_1')}
                editMode={newMode && !isDNAC}
                negativeMode={!isDNAC && entry.fields.amount_tax_1.value ? negativeMode : false}
                dashForNull={true}
                validator={this.amountValidator}
                validatorText={this.amountValidatorText}
              />
            </div>
            <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-2`}
                value={entry.fields.amount_tax_2.value}
                key={`amount--tax-2`}
                onChange={this._onChange('amount_tax_2')}
                editMode={newMode && !isDNAC}
                negativeMode={!isDNAC && entry.fields.amount_tax_2.value ? negativeMode : false}
                dashForNull={true}
                validator={this.amountValidator}
                validatorText={this.amountValidatorText}
              />
            </div>
            <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-3`}
                value={entry.fields.amount_tax_3.value}
                key={`amount--tax-3`}
                onChange={this._onChange('amount_tax_3')}
                editMode={newMode && !isDNAC}
                negativeMode={!isDNAC && entry.fields.amount_tax_3.value ? negativeMode : false}
                dashForNull={true}
                validator={this.amountValidator}
                validatorText={this.amountValidatorText}
              />
            </div>
            <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-4`}
                value={entry.fields.amount_tax_4.value}
                key={`amount--tax-4`}
                onChange={this._onChange('amount_tax_4')}
                editMode={newMode && !isDNAC}
                negativeMode={!isDNAC && entry.fields.amount_tax_4.value ? negativeMode : false}
                dashForNull={true}
                validator={this.amountValidator}
                validatorText={this.amountValidatorText}
              />
            </div>
            <div className="parkchirp--credit-panel-entry-table--gross-amount-column parkchirp--credit-panel-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--gross-amount`}
                value={gross}
                key={`gross-amount`}
                editMode={false}
                negativeMode={negativeMode}
              />
            </div>
          </>
        }
      </div>
    );
  }
}

export default CreditEntryTableRow;
